export type MarkdownReference = {
  name: string;
  link: string;
};

export const getReferencesFromMarkdown = (
  markdown?: string
): MarkdownReference[] => {
  if (!markdown) {
    return [];
  }

  const lines = markdown.split('\n');
  const referencesHeaderIndex = lines.findIndex(line =>
    line.trim().startsWith('#### References')
  );

  if (referencesHeaderIndex === -1) {
    return [];
  }

  const referencesLines = [];
  for (let i = referencesHeaderIndex + 1; i < lines.length; i++) {
    const line = lines[i];
    if (line.trim().startsWith('####')) {
      break; // Stop at the next section
    }
    referencesLines.push(line);
  }

  const referencesContent = referencesLines.join('\n');
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const matches = [...referencesContent.matchAll(linkRegex)];

  return matches.map(match => ({ name: match[1], link: match[2] }));
};

/**
 * Processes HTML content to replace single <br> and <br /> tags with spaces
 * while preserving double <br> tags for proper line breaks.
 * This fixes display issues in vulnerability definition content.
 */
export function processBrTags(htmlContent: string): string {
  if (!htmlContent) return htmlContent;

  return htmlContent
    .replace(/<br>(?!<br>)/g, ' ')
    .replace(/<br\s*\/?>(?!<br\s*\/?>)/g, ' ');
}
